import { useState } from "react";
import "./dc-router.css";
import { PromptPair } from "../../wazawan/Wazawan";
import { DCPreviewEmployeeRecord } from "./DCPreviewEmployeeRecord";
import { useSelector } from "react-redux";
import { selectUser } from "../../../redux/features/appData";
import { DCEmployeeRecord } from "./DCEmployeeRecord";
import { DCAsset } from "./DCAsset";
import { DCReporting } from "./DCReporting";
import { DCPTORequest } from "./DCPTORequest";
import { DCPTOBalance } from "./DCPTOBalance";
import { DCPTOHistory } from "./DCPTOHistory";

export const NR_DELETE_THIS_EMPLOYEE_RECORD_ID = "dbb8a0bf-509c-491c-9d20-ce5961515405";

export type DCUIContext = {
    employeeRecordIds: string[] | undefined;
}

type DCComponentRouterProps = {
    objectName: string;
    data: any;
}

export const DCComponentRouter = ({
    objectName,
    data,
    } : DCComponentRouterProps) => {

    const storeUser = useSelector(selectUser);

    console.log("[DCComponentRouter] objectName: ", objectName);
    console.log("[DCComponentRouter] data: ", data);
    
    return (
        <div 
            className="dc-component-router"
        >
            {(()=> {
                switch(objectName) {
                    case "pto-request":
                        return (
                            <DCPTORequest data={data} />
                        )
                    case "pto-balance":
                        return (
                            <DCPTORequest data={data} balanceOnly={true} />

                        )
                    case "pto-history":
                        return (
                            <DCPTOHistory data={data} />
                        )
                    case "asset":
                        return (
                            <DCAsset 
                                preview={true}
                                title={data.title || data.fileName || data.name}
                                url={data.cloudURL}
                                onCancel={() => console.log("Asset cancelled")}
                                onSubmit={() => console.log("Asset submitted")}
                            />
                        )
                    case "employee-record":
                        return (
                            <></>
                            // <DCEmployeeRecord 
                            //     id={NR_DELETE_THIS_EMPLOYEE_RECORD_ID}
                            //     // properties={[response.label]}
                            //     properties={[]}
                            //     onCancel={onCancel}
                            //     onSubmit={onSubmit}
                            // /> 
                        )
                    default:
                        return (
                            <span className="dc-component-router-default">
                                Unknown object: {objectName}<p/>
                                Data: {JSON.stringify(data)}
                            </span>
                        )
                }
                })()
            }   
           
        
        </div>
    )
}